export interface ItemShortInfoDto {
  id: number;
  name: string;
}
